import { z } from 'zod';
export const AppleLoginSchema = z.object({
    accessToken: z.string().optional()
});
//# sourceMappingURL=appleLoginSchema.js.map